import { createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';

export const initialState = {
  nextThematicAreaPage: 1,
  loadingThematicArea: false,
  thematicAreas: [],
  provinces: [],
  isMtot: false,
  isVirtual: false,
  isPhysical: false,
  eventType: false
};

// A slice

const eventFilterSlice = createSlice({
  name: 'eventFilter',
  initialState,
  reducers: {
    setThematicArea: (state, action) => {
      state.thematicAreas = action.payload.results;
      state.nextThematicAreaPage = action.payload.hasMore ? state.nextThematicAreaPage + 1 : null;
    },
    setThematicAreaLoading: (state, action) => {
      state.loadingThematicArea = action.payload;
    },
    setProvinces: (state, action) => {
      state.provinces = action.payload;
    },
    setProvincesLoading: (state, action) => {
      state.loadingProvinces = action.payload;
    },
    setMtot: (state, action) => {
      state.isMtot = action.payload;
    },
    setIsVirtual: (state, action) => {
      state.isVirtual = action.payload;
    },
    setIsPhysical: (state, action) => {
      state.isPhysical = action.payload;
    },
    setEventTypeFilter: (state, action) => {
      state.eventType = action.payload;
    }
  }
});

const {
  setThematicArea,
  setThematicAreaLoading,
  setProvinces,
  setProvincesLoading,
  setMtot,
  setIsVirtual,
  setIsPhysical,
  setEventTypeFilter
} = eventFilterSlice.actions;

export const eventFilterSelector = (state) => state.local;

const eventFilterReducer = eventFilterSlice.reducer;

export default eventFilterReducer;

// Actions
export const getThematicAreas =
  ({ page = 1, title_nepali, title_english }) =>
  async (dispatch) => {
    try {
      dispatch(setThematicAreaLoading(true));
      let url = `/thematicarea/?page=${page}`;
      if (title_english) {
        url += `&title_english=${title_english}`;
      }
      if (title_nepali) {
        url += `&title_nepali=${title_nepali}`;
      }
      url += '&limit=200';
      const response = await fetchWrapper.get(url);
      dispatch(setThematicArea({ results: response.data.results, hasMore: !!response.next }));
      dispatch(setThematicAreaLoading(false));
    } catch (error) {
      ErrorMessageHandler(error);
      dispatch(setThematicAreaLoading(false));
    }
  };

export const getProvinces = () => async (dispatch) => {
  try {
    dispatch(setProvincesLoading(true));
    const response = await fetchWrapper.get('/province/');
    dispatch(setProvinces(response.results));
    dispatch(setProvincesLoading(false));
  } catch (error) {
    ErrorMessageHandler(error);
    dispatch(setProvincesLoading(false));
  }
};

export const setMtotHandler = (value) => async (dispatch) => {
  try {
    dispatch(setMtot(value));
  } catch (error) {
    ErrorMessageHandler(error);
  }
};

export const setIsVirtualHandler = (value) => async (dispatch) => {
  try {
    dispatch(setIsVirtual(value));
  } catch (error) {
    ErrorMessageHandler(error);
  }
};

export const setIsPhysicalHandler = (value) => async (dispatch) => {
  try {
    dispatch(setIsPhysical(value));
  } catch (error) {
    ErrorMessageHandler(error);
  }
};
export const setEventTypeFilterHandler = (value) => async (dispatch) => {
  try {
    dispatch(setEventTypeFilter(value));
  } catch (error) {
    ErrorMessageHandler(error);
  }
};
